import isNil from 'lodash/isNil';

import { formatBoolean } from '../../../../../common/helpers/helpers';
import { ParticipationGridColDef, ParticipationRecordItem } from '../../types';

export type Value = ParticipationRecordItem['isRoadshowParticipant'];

export const isRoadshowParticipationColDef: ParticipationGridColDef<Value> = {
  field: 'isRoadshowParticipant',
  headerName: 'Roadshow Participation',
  cellDataType: 'string',
  floatingFilter: true,
  filter: 'agMultiColumnFilter',
  filterParams: {
    filters: [
      {
        filter: 'agTextColumnFilter',
      },
      {
        filter: 'agSetColumnFilter',
        filterParams: {
          values: [true, false],
          valueFormatter: ({ value }) => (isNil(value) ? '-' : formatBoolean(value)),
        },
      },
    ],
  },
  valueFormatter: ({ value }) => (isNil(value) ? '-' : formatBoolean(value)),
};

// csv header to field name mapping for upload participation set
export const isRoadshowParticipantHeaderMapping = {
  fieldName: 'isRoadshowParticipant',
  displayName: 'Roadshow Participation',
  acceptedHeaders: ['isRoadshowParticipant', 'Roadshow Participation'],
};
